import { useEffect, useRef } from 'react';

const useScrollListener = (onScroll) => {
    const contentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (contentRef.current) {
                onScroll(contentRef.current.scrollTop);
            }
        };

        contentRef.current.addEventListener('scroll', handleScroll);

        return () => {
            contentRef.current ? 
				contentRef.current.removeEventListener('scroll', handleScroll)
				: onScroll(0);
        };
    }, [onScroll]);


    return contentRef;
};

export default useScrollListener;